function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}

const trapFocusHandlers = {};
const warningTime = 3000

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });

    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });

    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }

    return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function extractContent(string) {
    var div = document.createElement('div');
    div.innerHTML = string;

    return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];

        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");

        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');

        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);

        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');

            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

Shopify.getCart = function (callback) {
    const format = window.switch_js_json || 'js';
    $.getJSON(`/cart.${format}`, function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            Shopify.onCartUpdate(cart);
        }
    });
}
Shopify.fetchCart = function () {
    const format = window.switch_js_json || 'js';
    return fetch(`/cart.${format}`)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
            throw error;
        });
}
Shopify.getCartAsync = async function (callback) {
    try {
        const cart = await Shopify.fetchCart();
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            Shopify.onCartUpdate(cart);
        }
        return cart;
    } catch (error) {
        console.error('Error in getCartAsync:', error);
        if ((typeof callback) === 'function') {
            callback(null, error);
        }
        throw error;
    }
}

Shopify.fetchCartInfo = async function () {
    const format = window.switch_js_json || 'js';
    const response = await fetch(`/cart.${format}`, { method: 'GET' });
    return await response.json();
}

Shopify.onCartUpdate = function (cart) {
    alert('There are now ' + cart.item_count + ' items in the cart.');
}

Shopify.changeItem = function (variant_id, quantity, callback, properties) {
    const format = window.switch_js_json || 'js';
    let data = {
        id: variant_id,
        quantity
    };
    if (properties) data = { ...data, properties }
    var params = {
        type: 'POST',
        url: `/cart/change.${format}`,
        data: data,
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };

    $.ajax(params);
}

Shopify.changeLineItem = function (lineKey, quantity, options = {}) {
    const {
        success = Shopify.onCartUpdate,
        error = (err) => Shopify.onError({ responseText: JSON.stringify({ description: err.message }) }),
        properties,
        forceDirectAPI = false
    } = options;

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const targetItem = cart.items.find(item => item.key === lineKey);
            if (!targetItem) {
                error(new Error(`Line item not found: ${lineKey}`));
                return;
            }
            
            const sameVariantItems = cart.items.filter(item => item.variant_id === targetItem.variant_id);
            const hasMultipleVariants = sameVariantItems.length > 1;
            
            const finalProperties = { ...targetItem.properties };
            if (properties) {
                Object.assign(finalProperties, properties);
            }
            
            if (hasMultipleVariants || forceDirectAPI) {
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: lineKey,
                        quantity: quantity,
                        properties: finalProperties
                    })
                })
                .then(response => response.json())
                .then(updatedCart => {
                    success(updatedCart);
                })
                .catch(error);
            } else {
                Shopify.changeItem(targetItem.variant_id, quantity, success, finalProperties);
            }
        })
        .catch(error);
}

Shopify.removeItem = async function (variant_id, callback) {
    const format = window.switch_js_json || 'js';
    var params = {
        type: 'POST',
        url: `/cart/change.${format}`,
        data: 'quantity=0&id=' + variant_id,
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };

    await $.ajax(params);
}

Shopify.clearCart = async function (callback) {
    const format = window.switch_js_json || 'js';
    var params = {
        type: 'POST',
        url: `/cart/clear.${format}`,
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                window.location.reload();
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };

    await $.ajax(params);
}
Shopify.createDeliveryDate = async function () {
    let dates = [];

    try {
        const format = window.switch_js_json || 'js';
        const response = await $.ajax({
            type: "GET",
            url: `/cart.${format}`,
            dataType: "json"
        });

        const cartItems = response.items || [];

        cartItems.forEach((item) => {
            const itemDate = item.properties["Delivery Date"];
            if (itemDate) {
                dates.push(new Date(itemDate));
            }
        });

        const earlyDeliveryDate = getFormattedDate(getEarlyDeliveryDate(dates));
        return earlyDeliveryDate;
    } catch (error) {
        console.error("Failed to retrieve cart items:", error);
        return null;
    }
};

function getEarlyDeliveryDate(dates) {
    if (dates.length === 0) {
        return null;
    }

    const minDate = new Date(Math.min(...dates));
    return minDate;
}

function getFormattedDate(date) {
    if (!date) {
        return null;
    }

    const formattedDate = date.toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    return formattedDate;
}

Shopify.addItem = async function (productTitle, productHandle, variantId, quantity, callback, input = null) {
    const deliveryDate = await Shopify.createDeliveryDate();
    var quantity = quantity || 1;
    var target = document.querySelector('[data-quickshop] .is-loading') || document.querySelector('[data-btn-addtocart].is-loading');
    let associativeID = Math.random().toString(36).substring(2, 9);
    let formData = {
        'items': [{
            'id': variantId,
            'quantity': quantity,
            'properties': {
                'Delivery Date': deliveryDate,
                _handle: productHandle,
                _associativeName: productTitle,
                _associativeID: associativeID
            }
        }]
    };

    const format = window.switch_js_json || 'js';
    var params = {
        type: 'POST',
        url: `/cart/add.${format}`,
        data: formData,
        dataType: 'json',
        success: function (line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                Shopify.onItemAdded(line_item);
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            // console.log(XMLHttpRequest)
            var message = window.cartStrings.addProductOutQuantity2;
            if (input.length > 0) {
                var maxValue = parseInt(input.attr('data-inventory-quantity'));
                message = getInputMessage(maxValue)
                input.val(maxValue)
            }

            const errorDescription = XMLHttpRequest.responseJSON.description.toLowerCase()
            if (errorDescription.includes(window.cartStrings.soldoutText) || errorDescription.includes(window.cartStrings.alreadyText)) {
                message = XMLHttpRequest.responseJSON.description
            }

            Shopify.onError(XMLHttpRequest, textStatus, message);
            target?.classList.remove('is-loading');
        }
    };
    $.ajax(params);
}

Shopify.onItemAdded = function (line_item) {
    alert(line_item.title + ' was added to your shopping cart.');
}

Shopify.onError = function (XMLHttpRequest, textStatus, message) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        // if (window.innerWidth >= 767) {
        //     showWarning(data.message + '(' + data.status  + '): ' + data.description, warningTime);
        // } else {
        showWarning(data.message + ': ' + message, warningTime);
        // }
    } else {
        // if (window.innerWidth >= 767) {
        //     showWarning('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.', warningTime);
        // } else {
        showWarning('Error : ' + message, warningTime);
        // }
    }
}

class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        const summaryElements = this.querySelectorAll('summary');
        this.addAccessibilityAttributes(summaryElements);

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    addAccessibilityAttributes(summaryElements) {
        summaryElements.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', element.nextElementSibling.id);
        });
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
            });
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');

            this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });

            this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
            document.body.classList.remove('overflow-hidden-mobile');
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');

                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

if (!customElements.get('menu-drawer')) {
    customElements.define('menu-drawer', MenuDrawer);
}


class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }
}

if (!customElements.get('header-drawer')) {
    customElements.define('header-drawer', HeaderDrawer);
}

class UpdateQuantity extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }
    onButtonClick(event) {
        event.preventDefault();
        let el_input = event.target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = el_input.dataset.inventoryQuantity;
        const atcButton = el_input.closest('.productView-product')?.querySelector('[data-btn-addtocart]');
        const saleOutStock = atcButton?.dataset.available === 'true'
            || atcButton?.dataset.available === 'no-track-quantity'
            || atcButton?.dataset.available == null
            || false
        if (event.target.classList.contains('plus')) {
            var newVal = value + 1;
        } else {
            var newVal = value - 1;
        }

        if (newVal < 0) {
            var newVal = 1
        }

        if (newVal > inStockNumber && !saleOutStock) {
            var arrayInVarName = `cart_selling_array_${this.dataset.product}`,
                itemInArray = window[arrayInVarName],
                itemStatus = itemInArray[this.dataset.variant];


            if (itemStatus == 'deny') {
                alert('update quan')
                const message = getInputMessage(inStockNumber);
                showWarning(message, warningTime);
                var newVal = inStockNumber
            }
        }

        el_input.value = newVal;
        this.input.dispatchEvent(this.changeEvent);
    }
}

class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        let el_input = event.target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = el_input.dataset.inventoryQuantity;
        const atcButton = el_input.closest('[data-quickshop]').querySelector('[data-btn-addtocart]');

        if (event.target.classList.contains('plus')) {
            var newVal = value + 1;
        } else {
            var newVal = value - 1;
        }

        if (newVal <= 0) {
            var newVal = 1
        }

        if (newVal > inStockNumber && (atcButton.dataset.available != 'true' && atcButton.dataset.available != 'no-track-quantity')) {
            alert('update quick quan')
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            var newVal = inStockNumber
        }

        el_input.value = newVal;
        this.input.dispatchEvent(this.changeEvent);
        const quickshop = this.closest('[data-quickshop]');
        const realQuantityInput = quickshop.querySelector('form input[type="hidden"]');
        realQuantityInput.setAttribute('value', newVal);
    }
}


window.addEventListener('load', () => {
    if (!customElements.get('cart-update-quantity')) {
        customElements.define('cart-update-quantity', UpdateQuantity);
    }
    if (!customElements.get('quickshop-update-quantity')) {
        customElements.define('quickshop-update-quantity', UpdateQuantityQuickShop);
    }
});


function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}

(function (eventDateUtils) {

    eventDateUtils.isValidDate = (dateString) => {
        function isDateFormatValid(dateString) {
            const datePattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
            return datePattern.test(dateString);
        }

        function parseDate(dateString) {
            const [month, day, year] = dateString.split("/").map(Number);
            return { day, month, year };
        }

        function isYearMonthValid(year, month) {
            const isYearInRange = year >= 1000 && year <= 3000;
            const isMonthInRange = month >= 1 && month <= 12;
            return isYearInRange && isMonthInRange;
        }

        function isLeapYear(year) {
            return year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);
        }

        function isDayValid(day, month, year) {
            const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            if (isLeapYear(year)) {
                monthLength[1] = 29;
            }

            return day > 0 && day <= monthLength[month - 1];
        }

        if (!isDateFormatValid(dateString)) {
            return false;
        }

        const { day, month, year } = parseDate(dateString);
        if (!isYearMonthValid(year, month)) {
            return false;
        }

        return isDayValid(day, month, year);
    };

    eventDateUtils.handleLocalStorage = (action, eventType, eventData = "") => {

        if (typeof localStorage === "undefined") {
            console.log("localStorage is not available in this environment.");
            return;
        }

        const key = `${eventType}-customer`;
        try {
            switch (action) {
                case "get":
                    return localStorage.getItem(key) || null; 
                case "set":
                    localStorage.setItem(key, eventData);
                    break;
                case "remove":
                    localStorage.removeItem(key);
                    break;
                default:
                    console.error("Invalid action specified.");
            }
        } catch (e) {
            console.log("Error accessing localStorage:", e);
        }
    };


    eventDateUtils.updateAttributes = async (data) => {
        const attributesData = { 'attributes': data };
        try {
            const format = window.switch_js_json || 'js';
            let response = await fetch(`/cart/update.${format}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(attributesData)
            });
            return response.json();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    eventDateUtils.updateUiCheckOutButton = (isDisabled) => {
        // Implementation here , deprecated by now
    };

    eventDateUtils.updateUIDate = (isChecked, eventDate, locatedID) => {
        const datePickerSelector = `#datePicker_EventDate_${locatedID}`;
        const checkboxSelector = `#checkout_haveEventDate_${locatedID}`;
        const backgroundColor = isChecked ? "#F2F2F2" : "white";

        $(datePickerSelector).css("background-color", backgroundColor).val(isChecked ? "" : eventDate);
        $(checkboxSelector).prop("checked", isChecked);
    };

    eventDateUtils.enableDate = (locatedID) => {
        const eventDate = $(`#datePicker_EventDate_${locatedID}`).val();
        if (eventDate) {
            eventDateUtils.handleLocalStorage("set", "event-date", eventDate);
            eventDateUtils.updateUIDate(false, eventDate, locatedID);
            eventDateUtils.updateAttributes({ event_date: eventDate });
        }
    };

    eventDateUtils.disableDate = (locatedID) => {
        const eventDate = $(`#datePicker_EventDate_${locatedID}`).val();
        const hasEventDate = $(`#checkout_haveEventDate_${locatedID}`).is(":checked");

        eventDateUtils.updateUIDate(hasEventDate, eventDate, locatedID);

        if (hasEventDate) {
            eventDateUtils.handleLocalStorage("remove", "event-date");
            eventDateUtils.updateAttributes({ event_date: "" });
            eventDateUtils.validateButtonCheckout(false);
        } else if (eventDate && eventDateUtils.isValidDate(eventDate)) {
            eventDateUtils.handleLocalStorage("set", "event-date", eventDate);
            eventDateUtils.updateAttributes({ event_date: eventDate });
            eventDateUtils.validateButtonCheckout(false);
        } else {
            eventDateUtils.validateButtonCheckout(true);
        }
    };

    eventDateUtils.showValidateEventDate = (hide) => {
        // Implementation here , deprecated by now
    };

    eventDateUtils.validateButtonCheckout = (block) => {
        const checkoutButtonSelector = template_location === "cart" ? "#cart-checkout" : "#cart-sidebar-checkout";
        const shouldDisable = Boolean(block);

        $(checkoutButtonSelector).prop('disabled', shouldDisable);
        event_date_accept = !shouldDisable;
    };

})(window.eventDateUtils = window.eventDateUtils || {});

